import { deviceType, batteryLevel as batteryLevelConst } from "../constant";

export const batteryLevel = (car, shouldDisplayBatteryInfo, siteSettingsData) => {
    if (car.UseVoltage && ![deviceType.VDU3, deviceType.VDU4].car?.DevType) return car.BatteryVoltage?.toFixed(1) + 'v';

    if (car.BatteryLevel > 100) return '?';

    if (car.IsCharging) return '';                  // don't show % when on charge

    if (!shouldDisplayBatteryInfo && 
        siteSettingsData && 
        !siteSettingsData.ShowBatteryLevel && 
        (car.BatteryLevel > batteryLevelConst.warning)) return '';   // don't show % while green unless admin or site has permission to see them
    
    return car.BatteryLevel ? car.BatteryLevel.toString() + '%' : '0%';
};